"use client";

import { ApolloClient, HttpLink, InMemoryCache } from "@apollo/client";
import { PropsWithChildren, useMemo } from "react";
import { ApolloProvider } from "@apollo/client/react";

const STRAPI_URL = process.env.STRAPI_URL || "http://localhost:1337";

// Create a stable Apollo Client instance (client-side only provider usage)
function createApolloClient() {
    return new ApolloClient({
        cache: new InMemoryCache(),
        link: new HttpLink({
            uri: `${STRAPI_URL}/graphql`,
        }),
        devtools: {
            enabled: process.env.NEXT_PUBLIC_APP_ENV !== "production",
        }
    });
}

export function ApolloWrapper({ children }: PropsWithChildren) {
    // Ensure a single client instance per provider mount
    const client = useMemo(() => createApolloClient(), []);
    return <ApolloProvider client={client}>{children}</ApolloProvider>;
}
